function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { CALL_API } from "../middleware/api";
import { urlSearchParams } from "../constants";
export var GET_EVENTS_REQUEST = "GET_EVENTS_REQUEST";
export var GET_EVENTS_SUCCESS = "GET_EVENTS_SUCCESS";
export var GET_EVENTS_FAILURE = "GET_EVENTS_FAILURE";
export var loadEvents = function loadEvents(page, size, idFilterValue, userIdFilterValue, userIdFilterMode, typeIdFilterValue, startCreatedAtFilterValue, endDCreatedAtFilterValue) {
  return function (dispatch, getState) {
    var queryString = urlSearchParams({
      page: page,
      size: size,
      sort: "createdAt,desc",
      projection: "withCreatedByAndTypeAndObjects",
      idFilterValue: idFilterValue,
      userIdFilterValue: userIdFilterValue,
      userIdFilterMode: userIdFilterMode,
      typeIdFilterValue: typeIdFilterValue,
      startCreatedAtFilterValue: startCreatedAtFilterValue,
      endDCreatedAtFilterValue: endDCreatedAtFilterValue
    });
    return dispatch(_defineProperty({}, CALL_API, {
      types: [GET_EVENTS_REQUEST, GET_EVENTS_SUCCESS, GET_EVENTS_FAILURE],
      endpoint: "events/search/findAll".concat(queryString),
      init: {
        credentials: "same-origin"
      }
    }));
  };
};